/**
 * Admin REST API client — /api/admin/users CRUD
 */

const BASE = '/api/admin/users';

const req = (method: string, path: string, body?: unknown) =>
  fetch(`${BASE}${path}`, {
    method,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: body !== undefined ? JSON.stringify(body) : undefined,
  }).then(async (res) => {
    if (!res.ok) {
      const text = await res.text().catch(() => res.statusText);
      throw new Error(text || `HTTP ${res.status}`);
    }
    if (res.status === 204) return undefined;
    return res.json();
  });

export interface User {
  id: string;
  username: string;
  role: string;
  org_id: string | null;
  org_name: string | null;
  created_at: string;
}

export const adminApi = {
  list: (): Promise<User[]> =>
    req('GET', ''),

  create: (username: string, password: string, role: string, org_id?: string | null): Promise<User> =>
    req('POST', '', { username, password, role, org_id: org_id || null }),

  update: (id: string, data: { role?: string; password?: string; org_id?: string | null }): Promise<User> =>
    req('PATCH', `/${id}`, data),

  delete: (id: string): Promise<void> =>
    req('DELETE', `/${id}`),
};
